import Video from '../components/Video';
import LazyLoader from '../helpers/LazyLoader';

export default class DynamicVideo {
  constructor(section) {
    this.el = section.el;
    this.autoplay = section.data.autoplay;
    this.init = this.init.bind(this);

    this.lazyLoader = new LazyLoader(this.el, this.init);
  }

  init() {
    const videoEl = this.el.querySelector('[data-video]');

    this.hasPlayed = false;

    if (videoEl) {
      this.video = new Video(videoEl);
      this.bindEvents();
    }
  }

  bindEvents() {
    window.addEventListener('scroll', () => {
      if (this.autoplay) {
        var rect = this.el.getBoundingClientRect();

        if (rect.top >= 0 || rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
          if (!this.hasPlayed) {
            this.video._autoplay();
            this.hasPlayed = true;
          }
        } else {
          this.video._onPauseClick();
        }
      }
    });
  }

  onSectionUnload() {
    if (this.video) {
      this.video.unload();
    }

    this.lazyLoader.unload();
  }
}
